"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// The global registry for action types. Use `createAction` in `helpers.js` to
// register new actions.
var types = {};
exports.default = types;